import { render, staticRenderFns } from "./FooterMenuCard.vue?vue&type=template&id=79748d69"
import script from "./FooterMenuCard.vue?vue&type=script&lang=js"
export * from "./FooterMenuCard.vue?vue&type=script&lang=js"
import style0 from "./FooterMenuCard.vue?vue&type=style&index=0&id=79748d69&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports